import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {WordMasksController} from "./WordMasks";
import {WordMaskObject} from "../../types.d";

interface WordMaskProps {
    title?: string;
    words: any[];
    filter?: string;
    controller: WordMasksController;
    onSelect: (word: WordMaskObject) => any;
}

@observer export class WordMask extends Component<WordMaskProps, any> {

    get filteredWords() {
        const { filter, words } = this.props;

        return words
            .filter(value => !filter || !filter.length || value.word.toLowerCase().includes(filter.toLowerCase()));
    }

    render() {
        const { words, title, filter, controller } = this.props;

        return <>
            <div className="card border-light search-words-mask-list m-0 mb-3">
                <div className="card-header p-2">
                    <span className="search-words-mask-title float-left">{ title }</span>
                    {/*<span className="search-words-mask-title-pos float-right">(word rank)</span>*/}
                </div>
                <div className="card-body p-0" style={{ height: 300 }}>
                    <select multiple className="search-words-mask form-control h-100" style={{ height: 200 }}>
                        { this.filteredWords.map(word => (
                            <option title={ word.word }
                                    key={ word.id }
                                    data-word={ word.word }
                                    data-counter={ word.rank }
                                    className={controller && controller.highlightedWords.includes(word.id) ? 'highlighted' : ''}
                                    onClick={e => this.props.onSelect && this.props.onSelect(word)}
                                    value={ word.id }>
                                { word.word } ({ word.rank })
                            </option>
                        )) }
                    </select>
                </div>
            </div>
        </>
    }

}
